



































































import { mapGetters } from "vuex";
import { Home } from "@/utils/constants";

export default {
  name: "FAQCollapseCard",

  data() {
    return {
      isOpen: -1,
      collapses: Object.values(Home.FaqCollapse)
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    }),

    hasOpenCard() {
      return this.isOpen > -1;
    }
  }
};
